import styled from 'styled-components';

export const StyledFeaturesList = styled.ul`
  display: flex;
  width: 100%;
  list-style: none;
  padding: 0;
  justify-content: space-between;

  @media(min-width: 500px) {
    justify-content: flex-start;
  } 

  li {
    display: flex;
    height: 24px;
    
    align-items: center;

    @media(min-width: 500px) {
      margin-right: 100px;
    } 

    img {
      height: 100%;
      margin-right: 15px;
    }

    span {
      text-transform: uppercase;
      color: #000000;
      font-family: "Open Sans";
      font-size: 10px;
      font-weight: 600;
    }
  }
`